import { render } from "./ChangePasscode.vue?vue&type=template&id=637689dd&scoped=true"
import script from "./ChangePasscode.vue?vue&type=script&lang=js"
export * from "./ChangePasscode.vue?vue&type=script&lang=js"

import "./ChangePasscode.vue?vue&type=style&index=0&id=637689dd&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.member/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-637689dd"]])

export default __exports__